import PickupHighcageCard from "./PickupHighcageCard";
import PickupHighcageDetails from "./PickupHighcageDetails";
import "./pickup_highcage.css";

/**
 * 🧾 viriyah_pickup_highcage_2p3p/index.js
 * Metadata + Export ของแพ็กเกจ “คอกสูง 2+ / 3+”/Users/apichet/Downloads/cheetah-insurance-app/frontend/src/packages/viriyah/motor/viriyah_pickup_highcage_2p3p/index.js
 */

export default {
  id: "viriyah_pickup_highcage_2p3p",
  company: "วิริยะประกันภัย",
  productLine: "motor",
  categories: ["pickup"],
  nameTH: "คอกสูง 2+ / 3+",
  description: "ประกันภัยรถปิกอัพ ≤ 4 ตัน มีคอกเหล็ก/ไม้/ตู้บรรทุก (Single Rate)",
  accent: "#1e40af",
  expiresAt: "2025-12-31",
  card: PickupHighcageCard,
  detail: PickupHighcageDetails,
  active: true,
};
